import { render, staticRenderFns } from "./AbsenceList.vue?vue&type=template&id=635cb4f2&scoped=true&"
import script from "./AbsenceList.vue?vue&type=script&lang=ts&"
export * from "./AbsenceList.vue?vue&type=script&lang=ts&"
import style0 from "./AbsenceList.vue?vue&type=style&index=0&id=635cb4f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635cb4f2",
  null
  
)

export default component.exports